import React from 'react';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './SectionContent.module.scss';

const SectionContent = ({ tag, children }) => (
  <div data-bem="SectionContent" data-tag={fromAnyToTrimmed(tag)} className={CN.component}>
    <div data-bem="SectionContent__children" className={CN.children}>
      {children}
    </div>
  </div>
);

export default SectionContent;
